"use strict";

var React = require("react/addons");
var createReactClass = require("create-react-class");
var classnames = require("_lib/utils/classnames").default;
var TouchMixin = require("_lib/ui/mixins/TouchMixin.jsx");

var ApplicationElement = createReactClass({
  mixins: [TouchMixin],

  /* lifecycle methods */
  getInitialState: function () {
    return {};
  },

  /* privates */
  _redirect: function () {
    this.props.redirect(this.props.path);
  },
  _redirectWithTouch: function (e) {
    this._endTouch(this._redirect, e);
  },

  /* render */
  render: function () {
    /* jshint ignore:start */
    var classes = classnames({
      ApplicationElement: true,
    });

    var appClasses = {
      viewer: classnames({
        ApplicationLogo: true,
        viewer: true,
      }),
      maker: classnames({
        ApplicationLogo: true,
        maker: true,
      }),
      view_design: classnames({
        ApplicationLogo: true,
        "view-design": true,
      }),
      reports: classnames({
        ApplicationLogo: true,
        reports: true,
      }),
      monitor: classnames({
        ApplicationLogo: true,
        monitor: true,
      }),
    };

    var iconClasses = {
      viewer: classnames({
        fa: true,
        "fa-desktop": true,
      }),
      maker: classnames({
        fa: true,
        "fa-cut": true,
      }),
      view_design: classnames({
        fa: true,
        "fa-cubes": true,
      }),
      reports: classnames({
        fa: true,
        "fa-area-chart": true,
      }),
      monitor: classnames({
        fa: true,
        "fa-mercury": true,
      }),
    };

    return (
      <div
        className={classes}
        onClick={this.touchProxy.bind(this, this._redirect, [])}
        onTouchStart={this._startTouch}
        onTouchMove={this._moveTouch}
        onTouchEnd={this._redirectWithTouch}
      >
        <div className="content">
          <div className={appClasses[this.props.type]}>
            <div className={"icon"}>
              <i className={iconClasses[this.props.type]} />
            </div>
          </div>
          <div className="title">
            {this.props.title}
            <span className="title-new">{this.props.newFlag ? "new!" : ""}</span>
          </div>
          <p>{this.props.desc}</p>
        </div>
      </div>
    );

    /* jshint ignore:end */
  },
});

module.exports = ApplicationElement;
